import React, { useState, useEffect, useCallback, useRef  } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styles from './Detaililustrasi.module.css'
import { getVideos } from '../../store/features/CameraAndSignatureSlice';
import Header from '../../component/Header/header';
import ProgressBar from '../../component/ProgressBar/progressbar';
import { getIllustrationSPAJ } from '../../store/features/IllustrationSPAJSlice'
import { updateStatusSpaj, updateStatusCustomer } from '../../store/features/SPAJSlice';
import Spinners from '../../component/Spinner/spinners';
import { StatusCustomer } from '../../component/Helper'
import { Document, Page } from 'react-pdf';
import AllPagesPDFViewer from "../../component/customPdf/all-pages";
import SinglePagePDFViewer from "../../component/customPdf/single-page";
// import {base64} from "../../component/base64"

export default function LandingPage() {
    let dispatch = useDispatch()
    let [loading, setLoading] = useState(false)
    let navigate = useNavigate()
    const { SPAJDetail } = useSelector((state) => state.SPAJsDetail)
    const { Ilustration } = useSelector((state) => state.Ilustration)
    const { DeviceId } = useSelector((state)=>state.DeviceId)
    const { SPAJs } = useSelector((state) => state.SPAJs)
    const [statusCustomer, setStatusCustomer] = useState("");
    const [isUnitLink, setIsUnitLink] = useState(0);
    const [numPages, setNumPages] = useState(0);
    const [lastPage, setLastPage] = useState(false);
    const [loadOke, setLoadOke] = useState(false)
    useEffect(() => {
        setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink));
        setIsUnitLink(SPAJs.spajHeader?.isUnitLink);
    }, [SPAJs])

    useEffect(() => {
        if (statusCustomer > 1) {
            setLastPage(true)
        }
    }, [statusCustomer])

    // useEffect(() => {
    //     setLoading(true)

    //     let dataIllustration = {
    //         deviceId: `${DeviceId.deviceId}`,
    //         userName: `${SPAJDetail.dataSpaj.email}`,
    //         spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`
    //     }
    //     dispatch(getIllustrationSPAJ(dataIllustration)).then(res => {
    //         setLoading(false)
    //     }).catch(err => {
    //         setLoading(false)
    //     })
    // }, [])

    const listInnerRef = useRef();

    const updateStatus = () => {
        setLoading(true)
        if (statusCustomer == 1) {
            let detailData = {
                deviceId: `${DeviceId.deviceId}`,
                userName: `${SPAJs.spajHeader?.userName}`,
                spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
                agentStatus: "IPC",
                customerStatus: "CI"
            }
            dispatch(updateStatusSpaj(detailData)).then(res => {
                // UPDATE LOCAL STATUS CUSTOMER KE CI
                dispatch(updateStatusCustomer("CI"));
            })
        }
        navigate('/spaj-detail');
        setLoading(false)
    }

    const onDocumentLoadSuccess = doc => {
        setNumPages(doc._pdfInfo.numPages)
        setLoadOke(true)
    }

    const endPage = () => {
    setLastPage(true)
    }

    const scroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight-5) {
                setLastPage(true)
            }
        }
    }

    return (
        <>
              {loading == true && <Spinners />}
            <div>
                <Header />
                <div>
                    <div className="g-0 welcome-container">
                        <div className={`position-relative ${styles.bgContainer}`}>
                        <ProgressBar step="1" status={statusCustomer} isUnitlink={isUnitLink} />
                            <div className={styles.allCardGrey}>
                                <div className={styles.cardContainer}>
                                    <div style={{width:'100%', height:'100%', overflowX: 'auto'}}  ref={listInnerRef}>
                                        {/* <embed src={`data:application/pdf;base64,${Ilustration?.b64Illus}`} width="100%" height="100%" /> */}
                                        {/* <iframe src={`data:application/pdf;base64,${Ilustration?.b64Illus}#toolbar=0`} width="100%" height="100%"/> */}

                                        <AllPagesPDFViewer pdf={`data:application/pdf;base64,${Ilustration?.b64Illus}`} onLoadSuccess={onDocumentLoadSuccess} onEndPage={()=> endPage()} />

                                        {/* <Document file={`data:application/pdf;base64,${Ilustration?.b64Illus}`} onLoadSuccess={onDocumentLoadSuccess}>
                                            {Array.from(new Array(numPages), (el, index) => (
                                            <Page
                                                key={`page_${index + 1}`}
                                                pageNumber={index + 1}
                                                width={600}
                                            />
                                            ))}
                                        </Document> */}

                                    </div>
                                    <div className={styles.posbuttonFloatingUp}>
                                        <button className={styles.buttonFloatingUp}
                                            onClick={() => {listInnerRef.current.scrollTo(-100, -100); window.scrollTo(-100, -100); console.log(listInnerRef.current,"wkkwwk")}}><img src="images/up-arrow.png" width="20" /></button>
                                    </div>
                                    <div className={`position-relative`} style={{height: 20,marginTop: 30}}>
                                        <div className={styles.pbotton}>
                                            <div style={{display: 'flex', justifyContent:'flex-end'}}>
                                                <div >
                                                    <button
                                                        className={ onDocumentLoadSuccess ? styles.buttonnext : styles.buttonnextDisable}
                                                        disabled={!onDocumentLoadSuccess}
                                                        onClick={() => {
                                                        updateStatus();
                                                        navigate('/spaj-detail');
                                                    }}>Selanjutnya</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className={styles.linkFooter}>
                            <div>www.generali.co.id</div>
                        </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
